/**
 * A link to a certain page, an anchor tag
 */

import styled from 'styled-components';

const ButtonAction = styled.button`
  padding-left: 60px;
  padding-right: 60px;
  background-color: rgba(60,211,207,1);
  line-height: 38px;
  font-family: 'Montserrat';
  font-size: 15px;
  color: rgba(255,255,255,1);
  text-align: center;
  -webkit-letter-spacing: 0.01em;
  -moz-letter-spacing: 0.01em;
  -ms-letter-spacing: 0.01em;
  letter-spacing: 0.01em;
  border-radius: 20px;
`;

export default ButtonAction;


// WEBPACK FOOTER //
// ./src/components/ButtonAction/index.js